module.exports = __webpack_public_path__ + "media/images/lps-spending_graph-b4e8167d.png";